import {createRouter, createWebHistory} from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import SendView from '@/views/SendView.vue';
import ManageView from '@/views/ManageView.vue';
import ShareView from '@/views/ShareView.vue'; // NEW

const routes = [
    {path: '/', name: 'home', component: HomeView},
    {path: '/send', name: 'send', component: SendView},
    {path: '/manage', name: 'manage', component: ManageView},
    {path: '/share', name: 'share', component: ShareView}
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router;
